import Vue from 'vue'
import formatNumber from '~/utils/formatNumber'

Vue.filter('formatNumber', formatNumber)
Vue.prototype.$formatNumber = formatNumber
